<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="props.size" :background="props.background" viewBox="0 0 17 16">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.60846 0.926059C3.86829 1.08664 4.02645 1.37031 4.02645 1.67575L4.02625 5.64169C4.02625 6.12843 3.63167 6.52301 3.14493 6.52301C2.6582 6.52301 2.26362 6.12843 2.26362 5.64169L2.26381 3.10176L1.77663 3.34535C1.34127 3.56303 0.811889 3.38656 0.594213 2.95121C0.376537 2.51586 0.552998 1.98647 0.988351 1.7688L2.75099 0.887478C3.02419 0.750878 3.34864 0.765477 3.60846 0.926059ZM8.43307 2.99773C7.94633 2.99773 7.55175 3.39231 7.55175 3.87905C7.55175 4.36579 7.94633 4.76037 8.43307 4.76037H15.4836C15.9704 4.76037 16.3649 4.36579 16.3649 3.87905C16.3649 3.39231 15.9704 2.99773 15.4836 2.99773H8.43307ZM8.43285 11.3703C7.94611 11.3703 7.55153 11.7648 7.55153 12.2516C7.55153 12.7383 7.94611 13.1329 8.43285 13.1329H15.4834C15.9701 13.1329 16.3647 12.7383 16.3647 12.2516C16.3647 11.7648 15.9701 11.3703 15.4834 11.3703H8.43285Z"
      :class="colorClass"
    />

    <path
      d="M2.13962 11.1878L2.13863 11.1885L2.13747 11.1894L2.13573 11.1907L2.13485 11.1914C1.74928 11.4836 1.19953 11.4104 0.904071 11.0263C0.607301 10.6405 0.679475 10.0872 1.06528 9.79039L1.11659 9.75258C1.14278 9.73389 1.17804 9.70951 1.2213 9.68137C1.30716 9.6255 1.42802 9.55255 1.57498 9.47948C1.8551 9.34018 2.29617 9.16697 2.80212 9.16697C3.96493 9.16697 4.90757 10.1096 4.90757 11.2724C4.90757 11.9469 4.51234 12.4649 4.15845 12.8496C3.88874 13.1427 3.56309 13.3815 3.27713 13.5736H4.24658C4.73332 13.5736 5.1279 13.9681 5.1279 14.4549C5.1279 14.9416 4.73332 15.3362 4.24658 15.3362H1.3823C0.895557 15.3362 0.500977 14.9416 0.500977 14.4549C0.500977 13.7901 0.865366 13.3101 1.20603 12.9852C1.49467 12.7099 1.84125 12.4725 2.12858 12.2858L2.22202 12.225C2.56105 12.0033 2.80137 11.8335 2.96455 11.6561C3.10641 11.502 3.14493 11.3909 3.14493 11.2724C3.14493 11.0831 2.99145 10.9296 2.80212 10.9296C2.68143 10.9296 2.52275 10.9767 2.35979 11.0578C2.28521 11.0948 2.22368 11.1321 2.18255 11.1588C2.16231 11.172 2.1472 11.1824 2.13962 11.1878Z"
      :class="colorClass"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
